import Vue from "vue";
import Vuex from "vuex";

//MODULES-STORE
import { RECOVER_FORGOTTEN_PASSWORD  as RECOVERFORGOTTENPASSWORD } from "@/views/recover_forgotten_password/store/index.js";
import { PURCHASERECONCILIATION_MODULE as PURCHASERECONCILIATION } from "@/views/purchase_reconciliation/store/index.js";
import { CHANGEPASSWORD_SECURITY as CHANGEPASSWORDSECURITY} from "@/views/change_password_security/store/index.js";
import { MENUUSERCOMPANY_MODULE as MENUUSERCOMPANY } from "@/shared/components/menu_user_company/store/index";
import { NOTIFICATIONS_MODULE as NOTIFICATIONS } from "@/shared/components/notifications/store/index";
import { MARKETPLACE_MODULE as MARKETPLACE } from "@/views/categories_marketplace/store/index.js";
import { STARASSIGNMENT_MODULE as STARASSIGNMENT} from "@/views/star_assignment/store/index.js"
import { ICONS_MODULE as ICONS } from "@/shared/components/icons_selector/store/index";
import { RECOGNITION_MODULE as RECOGNITION } from "@/views/recognition/store/index.js";
import { SUPPLIERS_MODULE as SUPPLIERS } from "@/views/suppliers/store/index.js";
import { BOARD_MODULE as BOARD } from "@/views/categories_board/store/index.js";
import { USERS_ADMIN as USERSADMIN}  from "@/views/users_admin/store/index.js";
import { COMPANIES_MODULE as COMPANIES } from "@/views/companies/store/index";
import { NOVELTIES_MODULE as NOVELTIES } from "@/views/novelties/store/index";
import { PRODUCTS_MODULE as PRODUCTS } from "@/views/products/store/index";
import { REPORTS_MODULE as REPORTS } from "@/views/reports/store/index.js";
import { HAPPINESS_MODULE as HAPPINESS } from "@/views/chart/store/index";
import { CLIENTS_MODULE as CLIENTS } from "@/views/clients/store/index";
import { CARGUES_MODULE as CARGUES} from "@/views/cargues/store/index";
import { WELCOME_MODULE as WELCOME } from "@/views/home/store/index";
import { LOGIN_MODULE as LOGIN } from "@/views/login/store/index";
import { USERS_MODULE as USERS } from "@/views/users/store/index";
import { BONUS_MODULE as BONUS } from "@/views/bonus/store/index";
import { SHARED_MODULE as SHARED } from "@/shared/store/index";

Vue.use(Vuex);

export default new Vuex.Store({
  //   strict: true,
  modules: {
    RECOVERFORGOTTENPASSWORD,
    PURCHASERECONCILIATION,
    CHANGEPASSWORDSECURITY,
    MENUUSERCOMPANY,
    STARASSIGNMENT,
    NOTIFICATIONS,
    MARKETPLACE,
    RECOGNITION,
    USERSADMIN,
    SUPPLIERS,
    COMPANIES,
    HAPPINESS,
    NOVELTIES,
    PRODUCTS,
    CARGUES,
    REPORTS,
    CLIENTS,
    WELCOME,
    SHARED,
    LOGIN,
    USERS,
    BONUS,
    BOARD,
    ICONS,
  },
});
